<template>
  <div>
    <el-table :data="dataForTable" height="450" style="width: 100%;overflow: hidden;margin-top:10px;margin-bottom:10px;margin-left:10px;" show-summary >
      <el-table-column :prop="prop1" :label="label1" :width="width1"></el-table-column>
      <el-table-column :prop="prop2" :label="label2" :width="width2"></el-table-column>
      <el-table-column :prop="prop3" :label="label3" :width="width3"></el-table-column>
      <el-table-column :prop="prop4" :label="label4" :width="width4"></el-table-column>
    </el-table>
  </div>
</template>

<script type="text/javascript" scoped>
export default {
  props: ['prop1', 'prop2', 'label1', 'label2', 'prop3', 'label3', 'prop4', 'label4', 'width1', 'width2', 'width3', 'width4', 'dataForTable'],
  data () {
    return {
    }
  }
}
</script>

